import HowToLearnProductCardSkeleton from "@shared/components/howToLearnProduct/skeleton";
import { FC } from "react";

interface Props {
  count?: number;
}

const LandingProductLoading: FC<Props> = ({ count = 12 }) => {
  return (
    <>
      {Array(count)
        .fill("")
        .map((_, index) => {
          return (
            <div className="w-full mb-6 relative" key={index}>
              <span className="absolute z-10 h-6 w-6 fds-sm:h-7 fds-sm:w-7 -top-2.5 -right-3.5 flex text-center justify-center items-center body-sm fds-sm:body-md  rounded-full bg-fds-brand-light text-fds-on-brand-light " />
              <div key={index} className=" flex-1">
                <HowToLearnProductCardSkeleton />
              </div>
            </div>
          );
        })}
    </>
  );
};

export default LandingProductLoading;
